import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { SUPPORTED_FORMATS } from "../../constants/CommonConstants";

const useChosenFacilitySchema = () => {
  const { t } = useTranslation();
  return Yup.object().shape({
    facility_name_ar: Yup.string()
      .required(t("facility_ar_name_required"))
      .min(3, t("facility_name_at_least_3_characters")),
    facility_name_en: Yup.string()
      .required(t("facility_en_name_required"))
      .min(3, t("facility_name_at_least_3_characters")),
    AreaId: Yup.string().required(t("area_id_required")),
    CityId: Yup.string().required(t("city_id_required")),
    validationDocument: Yup.mixed()
      .required(t("file_required"))
      .test("fileType", t("unsupported_file_format"), (value: any) => {
        if (!value) return false;
        return SUPPORTED_FORMATS.includes(value.type);
      }),
  });
};

export default useChosenFacilitySchema;
